import  gql  from 'graphql-tag'

export const regionalReports = gql`query Regional($id: ID!, $reportStartDate: Date, $reportEndDate: Date){ 
    regionalReports: regional(id:$id){
        id
        name
        officeSet{
            edges{
                node{
                    id
                    name
                    inProcess(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate)
                    finished(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate)
                    averageTime(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate)
                    productionActivityCount(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate)
                    commerceActivityCount(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate)
                    servicesActivityCount(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate) 
                }
            }
        }
    }
}`;
